import _ from 'lodash';

import {
    COMEET_COMPANY_ID,
    COMEET_TOKEN,
    COMEET_URL,
    LOCATION_KEYS,
    DEPARTMENT_KEYS,
    COMEET_FILE_NAME,
    COMPANY_NAME,
    COMPANY_COLOR,
    COMPANY_FONT_SIZE,
} from '../shared/comeet/comeet_api/constants';
import { loadScript } from './loadScripts';

const OTHER = 'other';

export function loadComeetAssets() {
    const loadScriptURL = `${COMEET_URL}/${COMEET_FILE_NAME}`;
    return loadScript(loadScriptURL, {
        attributes: {
            id: 'comeet-jsapi',
            async: true,
        },
    });
}

export function initComeet() {
    if (window.COMEET) {
        window.COMEET.init({
            token: COMEET_TOKEN,
            'company-uid': COMEET_COMPANY_ID,
            'company-name': COMPANY_NAME,
            color: COMPANY_COLOR,
            'font-size': COMPANY_FONT_SIZE,
        });
    }
}

export function jobsLocations() {
    const locations = Object.values(LOCATION_KEYS);

    locations.push(OTHER);

    return locations;
}

export function jobsDepartments(positions = []) {
    let depName;
    const departments = {};

    Object.values(DEPARTMENT_KEYS).forEach((depKey) => (departments[depKey] = 0));

    return positions.reduce((acc, position) => {
        depName = position.department_slug || OTHER;
        acc[depName] = acc[depName] ? ++acc[depName] : 1;
        return acc;
    }, departments);
}

export const getPositionById = (positions, decodedId) => positions.find((position) => position.uid === decodedId);

export const filterPositionsBy = (positions, key, value) =>
    positions.filter((position) => _.get(position, key) === value);

export function extractYoutubeVideoId(url = '') {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url.match(regExp);

    return match && match[7].length === 11 ? match[7] : false;
}

export const stripHtmlTags = (html = '') => html.replace(/(<([^>]+)>)/gi, '');

/**
 * Filter all the positions that aren't include in
 * the list of cities as shown on the index page
 * @param {Array} positions
 * @returns {Array} global positions
 */
export const filterGlobalPositions = (positions = []) => positions.filter((position) => position.isGlobal);
